module.exports = __webpack_public_path__ + "img/界面简洁.8c1b5851.png";